<template>
  <div
    class="vacancy-one-response"
    :class="{
      '_new': resumeResponse.is_new,
      '_re-sent': resumeResponse.is_re_send,
      '_rejected': resumeResponse.rejected.status,
      '_invited': resumeResponse.invited_send,
    }"
    @click="onClick"
  >
    <div :style="gridColumns[0].style" class="vacancy-one-response__user-credentials">
      <div class="vacancy-one-response__avatar-wrap">
        <div class="vacancy-one-response__agent-avatar">
          <BaseAvatar
            :placeholder-name="showAgentData ? 'A' : null"
            size="1.6"
            font-size="1"
            :color="showAgentData ? '#0175ed' : 'transparent'"
          />
          <div v-if="showAgentData" class="vacancy-one-response__item-tooltip">{{ $tMyResponses('From agent') }}</div>
        </div>

        <div class="relative">
          <BaseMenu :card-style="{ transform: 'translate(-10%, -100%)', padding: '2rem', width: '28rem' }">
            <template v-slot:activator="{ on }">
              <BaseAvatar
                :style="{ cursor: showAgentData ? 'pointer' : 'default' }"
                :src="userAvatar"
                :placeholder-name="userFullName"
                size="4.8"
                v-on="showAgentData ? on : null"
              />
            </template>

            <div class="vacancy-one-response__employee-menu">
              <div><span>{{ $tMyResponses('Agent') }}</span> ID {{ $get(resumeResponse, 'agent_info.agent.id') }}</div>
              <div v-if="$get(resumeResponse, 'agent_info.agent.fullname')">
                {{ resumeResponse.agent_info.agent.fullname }}
              </div>
              <div v-if="$get(resumeResponse, 'agent_info.agent.phone')">
                {{ formatPhone(resumeResponse.agent_info.agent.phone) }}
              </div>
              <div class="vacancy-one-response__employee-menu-inset-block">
                <div><span>{{ $tMyResponses('Foreman') }}</span> ID {{ $get(resumeResponse, 'agent_info.foreman.id') }}</div>
                <div v-if="$get(resumeResponse, 'agent_info.foreman.fullname')">
                  {{ resumeResponse.agent_info.foreman.fullname }}
                </div>
                <div v-if="$get(resumeResponse, 'agent_info.foreman.phone')">
                  {{ formatPhone(resumeResponse.agent_info.foreman.phone) }}
                </div>
              </div>
            </div>
          </BaseMenu>
        </div>
      </div>

      <div>
        <div class="vacancy-one-response__name">
          <router-link-modified class="text-decoration-none" target="_blank" :to="resumeLink">
            {{ userFullName }}
          </router-link-modified>
        </div>
        <div class="account-vacancies-responses__description-text">
          <span>{{ userDescriptionText }}</span>
        </div>
        <div class="account-vacancies-responses__description-text vacancy-one-response__time-status-data">
          <div>{{ $tMyResponses('Responded') }}</div>
          <div>{{ resumeResponse.sent_resume_date }}</div>
          <div v-if="responseInviteStatus">
            {{ responseInviteStatus }}
          </div>
        </div>
      </div>
    </div>

    <div class="vacancy-one-response__contacts" :style="gridColumns[1].style">
      <div
        v-for="(item, index) in resumeResponse.resume[1].phones"
        :key="index"
      >
        <div class="vacancy-one-response__contacts-phone">
          <div v-if="resumeResponse.open_phone">{{ formatPhone(item.phone) }}</div>
          <button
            v-else
            class="base-btn base-btn--x-small base-btn--outline-dark"
            @click="openPhoneDialog"
          >
            {{ $tMyResponses('Show phone') }}
          </button>
        </div>
        <div class="vacancy-one-response__contacts-icons">
          <div v-if="item.telegram"><BaseSvg name="ico-telegram" width="1.7rem" height="1.5rem" class="telegram-icon" /></div>
          <div v-if="item.viber"><BaseSvg name="ico-viber" width="1.4rem" height="1.6rem" class="viber-icon" /></div>
        </div>
      </div>
    </div>

    <div class="vacancy-one-response__resume-fullness" :style="gridColumns[2].style">
      <div>
        <router-link-modified class="text-decoration-none" target="_blank" :to="resumeLink">
          <button class="base-btn base-btn--x-small base-btn--blue-dark">{{ $tMyResponses('Summary') }}</button>
        </router-link-modified>
      </div>
      <div class="vacancy-one-response__resume-fullness-icons">
        <div
          v-for="(item, index) in resumeFullnessItems"
          :key="index"
          :class="{ _filled: item.filled, _new: item.new }"
        >
          <BaseSvg :name="item.icon.name" :width="item.icon.width" :height="item.icon.height" />
          <div class="vacancy-one-response__resume-fullness-icon-new-circle"></div>

          <div class="vacancy-one-response__item-tooltip">{{ item.title }}</div>
        </div>
      </div>
    </div>

<!--  TODO temporary hide matching  -->
<!--    <div class="vacancy-one-response__vacancy-conformity" :style="gridColumns[3].style">-->
<!--      <ResumeConformityProgressMenu :match-data="vacancyMatchData">-->
<!--        <template v-slot:activator>-->
<!--          <ResumeConformityProgress v-model="vacancyConformityLevel" />-->
<!--        </template>-->
<!--      </ResumeConformityProgressMenu>-->

<!--      <span class="account-vacancies-responses__description-text">{{ $tMyResponses('Job matching') }}</span>-->
<!--    </div>-->

    <div class="vacancy-one-response__note-block" :style="gridColumns[4].style">
      <OneResponseNoteCard
        :value="resumeResponse.note && resumeResponse.note.text"
        :author-name="resumeResponse.note && resumeResponse.note.customer"
        :time="resumeResponse.note && resumeResponse.note.date"
        :resume-response="resumeResponse"
        class="full-width"
        @update:resume-response="updateLocalResumeResponse"
      />
      <TagsSelector
        v-if="isEmployer"
        :value="resumeResponse.tags"
        :sent-resume-id="resumeResponse.sent_resume_id"
        @create-tag="onTagCreate"
        @input="onTagsInput"
      />
    </div>

    <div class="vacancy-one-response__actions-menu" :style="gridColumns[5].style">
      <BaseMenu :card-style="{ transform: 'translate(-87%, -20%)' }" close-on-content-click>
        <template v-slot:activator="{ on }">
          <div class="vacancy-one-response__menu-dots">
            <button class="base-btn" v-on="on">
              <BaseSvg name="ico-dots" width="0.3rem" height="1.7rem" />
            </button>
          </div>
        </template>

        <div class="vacancy-one-response__actions-menu-card">
          <button
            v-if="isEmployer && !resumeResponse.rejected.status"
            class="base-btn base-btn--x-small"
            :class="{ 'base-btn--outline-dark': !resumeResponse.invited_send }"
            :style="resumeResponse.invited_send ? { backgroundColor: '#16C15B', color: 'white', cursor: 'default' } : null"
            @click="inviteToJob"
          >
            {{ $tMyResponses(resumeResponse.invited_send ? 'Invited to work' : 'Invite to work') }}
          </button>
          <button
            v-if="resumeResponse.need_accept"
            class="base-btn base-btn--x-small base-btn--outline-dark"
            @click="confirmResume"
          >
            {{ $tMyResponses('confirm_resume') }}
          </button>
          <button class="base-btn base-btn--x-small base-btn--outline-dark" @click="openShareResume">
            {{ $tMyResponses('Share resume') }}
          </button>
          <button class="base-btn base-btn--x-small base-btn--outline-dark" @click="goToResume">
            {{ $tMyResponses('Go to resume') }}
          </button>
          <button
            v-if="isEmployer"
            class="base-btn base-btn--x-small base-btn--outline-red"
            @click="decline"
          >
            {{ $tMyResponses(resumeResponse.rejected.status ? 'Rejected' : 'Reject') }}
          </button>
        </div>
      </BaseMenu>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {merge} from 'lodash';
import formatPhone from '../../helpers/formatPhone';
// import ResumeConformityProgress from '../resume-helpers/ResumeConformityProgress';
import OneResponseNoteCard from './OneResponseNoteCard';
// import ResumeConformityProgressMenu from '../resume-helpers/ResumeConformityProgressMenu';

export default {
  name: 'VacancyOneResponse',

  components: {
    // ResumeConformityProgressMenu,
    // ResumeConformityProgress,
    OneResponseNoteCard,
  },

  props: {
    gridColumns: {
      type: Array,
      required: true,
    },
    responseVacancy: {
      type: Object,
      required: true,
    },
    resumeResponse: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      genderList: [{
        id: 1,
        title: this.$tProfile('Male')
      }, {
        id: 2,
        title: this.$tProfile('Female')
      }],
    };
  },

  computed: {
    ...mapGetters('user', [
      'isModerator',
      'isEmployer',
      'isOurEmployer',
    ]),

    userFullName() {
      return this.resumeResponse.resume[1].surname + ' ' + this.resumeResponse.resume[1].name;
    },
    userAvatar() {
      return this.resumeResponse.resume[3].photos[0]?.path;
    },
    resumeLink() {
      return { name: 'received-resume', params: { resumeId: this.resumeResponse.sent_resume_id } };
    },
    userDescriptionText() {
      const { resume, age, country } = this.resumeResponse;
      const gender = this.genderList.find(g => g.id === resume[1].gender)?.title;
      const dataList = [];

      if (gender) dataList.push(gender);
      if (age) dataList.push(age + ' ' + this.$tMyResponses('years'));
      if (country && country.name) dataList.push(country.name);

      return dataList.join(', ');
    },
    responseInviteStatus() {
      switch (true) {
        case this.resumeResponse.rejected.status: return this.$tMyResponses('Rejected');
        case this.resumeResponse.invited_send: return this.$tMyResponses('accepted');
        case this.resumeResponse.is_new: return this.$tMyResponses('New');
        case this.resumeResponse.is_re_send: return this.$tResumePage('repeated_response');
        default: return null;
      }
    },
    resumeFullnessItems() {
      const { primary_questionnaire, passport } = this.resumeResponse.resume_additional;

      return [
        {
          title: this.$tMyResponses('Primary questionnaire'),
          icon: { name: 'ico-check-box', width: '1.2rem', height: '1.2rem' },
          filled: primary_questionnaire.status,
          new: primary_questionnaire.is_new,
        },
        {
          title: this.$tMyResponses('Passport'),
          icon: { name: 'ico-passport', width: '1.4rem', height: '1.2rem' },
          filled: passport.status,
          new: passport.is_new,
        },
      ];
    },
    vacancyConformityLevel() {
      return this.resumeResponse.vacancy_match;
    },
    vacancyMatchData() {
      return this.resumeResponse.vacancy_match_array || {};
    },
    showAgentData() {
      return (this.isOurEmployer || this.isModerator) && this.resumeResponse.is_a
    },
  },

  methods: {
    ...mapActions('helpers', [
      'canDoAction',
    ]),
    ...mapActions('vacancies/responses', [
      'inviteCandidateToJob',
      'setResumeMark',
      'createResumeTag',
      'saveResumeTags',
      'openResumePhone',
      'unsetResumeAsNew',
      'confirmCandidateResume',
    ]),

    formatPhone,

    async onClick() {
      if (!this.resumeResponse.is_new) return;

      const { sent_resume_id } = this.resumeResponse;
      const success = await this.unsetResumeAsNew({ sent_resume_id });
      if (success) this.updateLocalResumeResponse({ is_new: false });
    },
    updateLocalResumeResponse(deepObj) {
      const updatedItem = merge({}, this.resumeResponse, deepObj);
      this.$emit('update:resume-response', updatedItem);
    },

    async applyResumeMark(mark) {
      const success = await this.setResumeMark({ mark, resumeId: this.resumeResponse.sent_resume_id });
      if (success) {
        this.updateLocalResumeResponse({ mark });
      }
    },
    async openPhoneDialog() {
      const canSave = await this.canDoAction({ action: 'action_open_phones' });
      this.$vModal.open('confirm', {
        title: canSave.popup?.title || this.$tMyResponses('Show phone'),
        message: canSave.popup?.text || this.$tMyResponses('Want to open phone number'),
        successBtnClass: 'base-btn--outline-blue',
        onSuccess: () => {
          this.openPhone();
        },
      });
    },
    async openPhone() {
      const { sent_resume_id } = this.resumeResponse;
      const success = await this.openResumePhone({ sent_resume_id });
      if (success) {
        this.updateLocalResumeResponse({ open_phone: true });
        this.$emit('open-phone');
      }
    },

    async inviteToJob() {
      if (this.resumeResponse.invited_send) return;

      const vacancyId = this.responseVacancy.vacancy.ID;
      const resumeId = this.resumeResponse.sent_resume_id;

      const success = await this.inviteCandidateToJob({ vacancyId, resumeId });
      if (success) {
        this.updateLocalResumeResponse({ invited_send: true });
      }
    },
    async onTagCreate(tag, onSuccess) {
      const updatedTags = await this.createResumeTag({ tag, sent_resume_id: this.resumeResponse.sent_resume_id });
      if (updatedTags) {
        this.updateLocalResumeResponse({ tags: updatedTags });
        const newTag = updatedTags.find(t => t.name === tag.name);
        if (onSuccess) onSuccess(newTag);
        this.$emit('resume-tag-create');
      }
    },
    async onTagsInput(tags) {
      const statusOrTags = await this.saveResumeTags({ tags, sent_resume_id: this.resumeResponse.sent_resume_id });
      if (Array.isArray(statusOrTags)) {
        this.updateLocalResumeResponse({ tags: statusOrTags });
      } else if (statusOrTags) {
        this.$set(this.resumeResponse, 'tags', tags);
      }
    },
    goToResume() {
      this.$router.push(this.resumeLink);
    },
    confirmResume() {
      this.confirmCandidateResume({ sent_resume_id: this.resumeResponse.sent_resume_id })
        .then(() => this.resumeResponse.need_accept = false)
        .catch(() => this.$vModal.open('warning', { title: 'Something went wrong' }));
    },
    openShareResume() {
      this.$vModal.open('share-resume', {
        resumeId: this.resumeResponse.sent_resume_id,
        resume: this.resumeResponse.resume,
      });
    },
    decline() {
      if (this.resumeResponse.rejected.status) return;

      this.$vModal.open('reject-candidate', {
        resumeId: this.resumeResponse.sent_resume_id,
        onRejectSuccess: this.onRejectSuccess,
        redirect: false,
      });
    },
    onRejectSuccess() {
      this.$emit('reload');
    },
  },
};
</script>
